export enum LighthouseEnum {
   achievement_statuses = 'achievement_statuses',
   achievement_subtypes = 'achievement_subtypes',
   achievement_types = 'achievement_types',
   achievement_user_statuses = 'achievement_user_statuses',
   add_on_names = 'add_on_names',
   add_on_statuses = 'add_on_statuses',
   ad_event_providers = 'ad_event_providers',
   ad_event_statuses = 'ad_event_statuses',
   affiliate_disclaimer_display_strategies = 'affiliate_disclaimer_display_strategies',
   affiliate_calculation_types = 'affiliate_calculation_types',
   affiliate_creation_steps = 'affiliate_creation_steps',
   affiliate_event_statuses = 'affiliate_event_statuses',
   affiliate_programs = 'affiliate_programs',
   affiliate_providers = 'affiliate_providers',
   affiliate_reward_strategies = 'affiliate_reward_strategies',
   affiliate_statuses = 'affiliate_statuses',
   affiliate_types = 'affiliate_types',
   agent_permissions = 'agent_permissions',
   arcade_event_statuses = 'arcade_event_statuses',
   arcade_event_vendor_statuses = 'arcade_event_vendor_statuses',
   arcade_game_cost_models = 'arcade_game_cost_models',
   arcade_game_level_statuses = 'arcade_game_level_statuses',
   arcade_game_level_states = 'arcade_game_level_states',
   arcade_game_level_types = 'arcade_game_level_types',
   arcade_game_providers = 'arcade_game_providers',
   arcade_game_statuses = 'arcade_game_statuses',
   arcade_install_cap_frequencies = 'arcade_install_cap_frequencies',
   batch_workflow_names = 'batch_workflow_names',
   batch_workflow_statuses = 'batch_workflow_statuses',
   bridge_bucks_merchant_reward_strategies = 'bridge_bucks_merchant_reward_strategies',
   bridge_bucks_merchant_statuses = 'bridge_bucks_merchant_statuses',
   bridge_buck_statuses = 'bridge_buck_statuses',
   bridge_programs = 'bridge_programs',
   client_config_parent_types = 'client_config_parent_types',
   config_frequency_intervals = 'config_frequency_intervals',
   config_groups = 'config_groups',
   config_types = 'config_types',
   data_export_sources = 'data_export_sources',
   earn_task_names = 'earn_task_names',
   earn_task_types = 'earn_task_types',
   experiment_labeling_strategies = 'experiment_labeling_strategies',
   experiment_snapshot_formats = 'experiment_snapshot_formats',
   experiment_statuses = 'experiment_statuses',
   feed_names = 'feed_names',
   finix_cash_out_statuses = 'finix_cash_out_statuses',
   finix_event_entities = 'finix_event_entities',
   finix_event_statuses = 'finix_event_statuses',
   finix_event_types = 'finix_event_types',
   finix_link_statuses = 'finix_link_statuses',
   finix_link_types = 'finix_link_types',
   fraud_event_names = 'fraud_event_names',
   friend_relationship_statuses = 'friend_relationship_statuses',
   lighthouse_role_names = 'lighthouse_role_names',
   lighthouse_schema_names = 'lighthouse_schema_names',
   lighthouse_schema_portal_names = 'lighthouse_schema_portal_names',
   lighthouse_tag_groups = 'lighthouse_tag_groups',
   message_types = 'message_types',
   plaid_link_categories = 'plaid_link_categories',
   plaid_link_statuses = 'plaid_link_statuses',
   sdk_promotion_channels = 'sdk_promotion_channels',
   sdk_promotion_parent_types = 'sdk_promotion_parent_types',
   sdk_promotion_statuses = 'sdk_promotion_statuses',
   promotion_segmentations = 'promotion_segmentations',
   promotion_statuses = 'promotion_statuses',
   promotion_types = 'promotion_types',
   receipt_statuses = 'receipt_statuses',
   referral_owner_types = 'referral_owner_types',
   referral_statuses = 'referral_statuses',
   rent_reward_completions = 'rent_reward_completions',
   revenue_event_types = 'revenue_event_types',
   sailfish_question_types = 'sailfish_question_types',
   sailfish_redirect_sources = 'sailfish_redirect_sources',
   sailfish_redirect_statuses = 'sailfish_redirect_statuses',
   sailfish_survey_statuses = 'sailfish_survey_statuses',
   sardine_levels = 'sardine_levels',
   sardine_statuses = 'sardine_statuses',
   sleek_ingestion_statuses = 'sleek_ingestion_statuses',
   sleek_transaction_statuses = 'sleek_transaction_statuses',
   streak_names = 'streak_names',
   streak_statuses = 'streak_statuses',
   survey_providers = 'survey_providers',
   tillo_merchant_deliver_methods = 'tillo_merchant_deliver_methods',
   tillo_merchant_reward_strategies = 'tillo_merchant_reward_strategies',
   tillo_merchant_statuses = 'tillo_merchant_statuses',
   user_game_statuses = 'user_game_statuses',
   user_search_scopes = 'user_search_scopes',
   user_types = 'user_types',
}
